import { StrictTypedTypePolicies } from '../generated/apollo-helpers'

const typePolicies: StrictTypedTypePolicies = {}

export default typePolicies
